import { render } from "./OrdersList.vue?vue&type=template&id=47f0df5a&scoped=true&ts=true"
import script from "./OrdersList.vue?vue&type=script&lang=ts"
export * from "./OrdersList.vue?vue&type=script&lang=ts"

import "./OrdersList.vue?vue&type=style&index=0&id=47f0df5a&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f0df5a"]])

export default __exports__